import React, { useEffect, useState, type ReactElement } from 'react'
import { Form, Input, Select } from 'antd'
import { connect } from 'react-redux'
import {
    type HomeAddress,
    type HomeStateProps,
} from '../../../../../../Types/Client/RegisteredClients/Individual'
import PostCodeInput from '../../../../../../Components/PostCodeInput'
import { type ListFrontEndInterface } from '../../../../../../Types/CommonType'

const HomeAddressForm = (props: HomeAddress): ReactElement => {
    const { countryList, onDateChange, form } = props
    const [selectedCountry, setSelectedCountry] = useState<string>('')

    const [address, setAddress] = useState({
        line_1: '',
        line_2: '',
        line_3: '',
        post_town: '',
        postcode: '',
        country: '',
    })
    useEffect(() => {
        const countryData = countryList?.find(
            (data: ListFrontEndInterface) =>
                data.label === address?.country?.toUpperCase()
        )
        if (address.line_1 !== '') {
            const AddressData = {
                town: address.post_town,
                country: countryData?.label ?? '',
                postCode: address.postcode,
                addressOne: address?.line_1,
                addressTwo: address?.line_2,
            }
            form.setFieldsValue(AddressData)
        }
    }, [address])
    const handleCountryChange = (value: string): void => {
        setSelectedCountry(value)
        onDateChange(value)
    }

    return (
        <>
            <Form.Item
                label="Address 1"
                name="addressOne"
                rules={[
                    {
                        required: true,
                        message: 'Please input your Address one',
                    },
                ]}
            >
                <Input allowClear maxLength={100} />
            </Form.Item>
            <Form.Item label="Address 2" name="addressTwo">
                <Input allowClear />
            </Form.Item>
            <Form.Item
                label="Town"
                name="town"
                rules={[
                    {
                        required: true,
                        message: 'Please input your Town',
                    },
                ]}
            >
                <Input allowClear maxLength={50} />
            </Form.Item>
            <Form.Item
                label="Country"
                name="country"
                rules={[
                    {
                        required: true,
                        message: 'Please select Country',
                    },
                ]}
            >
                <Select
                    allowClear
                    showSearch
                    onChange={handleCountryChange}
                    options={countryList?.map((country: { label: any }) => ({
                        value: country.label,
                        label: country.label,
                    }))}
                    value={selectedCountry}
                />
            </Form.Item>

            <PostCodeInput
                name="postCode"
                label="Post Code"
                reuireMessage="Please Enter Post Code"
                placeHolder={''}
                setAddressDetails={setAddress}
            />
        </>
    )
}

const mapStateToProps = (state: any): HomeStateProps => {
    return {
        categoryDropDownList: state.initial.categoryDropDownList,
        countryList: state.common.countryList,
        individualTaps: state.client.individualTaps,
    }
}

export default connect(mapStateToProps)(HomeAddressForm)
